import SiteHeader from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { aboutSataraIntro, aboutSataraHighlights } from "../data/siteContent";

export default function OurStoryPage() {
  return (
    <>
      <SEO 
        title="Our Story"
        description="Learn about Gawkari Hillside's journey - from the heart of Satara district to your perfect Maharashtrian countryside escape."
      />
      <SiteHeader />
      <main>
        <section className="py-5">
          <div className="container" style={{maxWidth: '800px'}}>
            <div className="text-center mb-5">
              <span className="badge bg-green-lt mb-2 p-2">Our Story</span>
              <h1 className="display-4 fw-bold text-dark">The Gawkari Journey</h1>
            </div>
            
            <div className="vstack gap-3 text-secondary text-lg-start lead">
              {aboutSataraIntro.map((para, index) => (
                <p key={index}>{para}</p>
              ))}
            </div>
          </div>
        </section>

        <section className="py-5 bg-light">
          <div className="container">
            <div className="row row-cols-1 row-cols-md-2 g-4">
              {aboutSataraHighlights.map((block) => (
                <div key={block.title} className="col">
                  <div className="card h-100 p-4 border-0 shadow-sm" style={{background: 'linear-gradient(135deg, rgba(244, 214, 188, 0.45), rgba(154, 197, 89, 0.25))'}}>
                    <h3 className="h4 text-primary mb-3">{block.title}</h3>
                    <ul className="list-unstyled mb-0">
                      {block.points.map((point, index) => (
                        <li key={index} className="mb-2 d-flex align-items-start">
                          <span className="text-primary me-2">•</span>
                          <span>{point}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
